module.exports = __webpack_public_path__ + "media/images/icook-logo-a194f910723c71232ec2d227b093381c.svg";